<mat-menu [overlapTrigger]="true" class="ml-14">
  @for (route of routes; track route) {
  <button [queryParams]="route.queryParams" [routerLink]="route.url" mat-menu-item>
    @if (route.icon) {
    <mat-icon>{{ route.icon }}</mat-icon>
    }
    <span>{{ route.label }}</span>
  </button>
  }
</mat-menu>
